// extracted by mini-css-extract-plugin
export default {"NotFound":"NotFound_NotFound__k+enV","NotFoundText":"NotFound_NotFoundText__W1I6y"};